export default __webpack_public_path__ + "static/media/10.578e6bf4.jpg";